module.exports = __webpack_public_path__ + "img/stock7.51a8b163.png";